import type { IGraduationPlannerState } from '@/store/modules/graduationplanner/types';

export const state: IGraduationPlannerState = {
  ssoToken: '',
};
